import styled from 'styled-components';

export const AudioPlayerContainer = styled.div`
	/* border: 1px solid red; */
	flex-grow: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	audio {
		display: none;
		visibility: hidden;
	}
`;

export const Player = styled.div`
	position: relative;
	display: flex;
	width: 50%;
	max-width: 150px;
	/* height: 50%; */
	aspect-ratio: 1/1;
	margin: 1rem;
`;

interface PulseDelay {
	$delay: number;
}

export const AudioPulse = styled.div`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	background: rgba(var(--ion-color-light-rgb), 0.25);
	border-radius: 50%;
	transform: scale(1);
	z-index: 0;
	transition: transform 0.3s;
	&.playing {
		animation: pulse 1.5s ${(props: PulseDelay) => props.$delay}s alternate
			infinite ease-out;
	}
`;

export const AudioTrigger = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	width: 100%;
	height: 100%;
	background: var(--ion-color-secondary);
	border-radius: 50%;
	align-items: center;
	justify-content: center;
	box-shadow: var(--generic-box-shadow);
	border: 2px solid var(--ion-color-light-shade);
	ion-icon {
		font-size: 3rem;
	}
`;
